import React from 'react'
import PropTypes from 'prop-types'
import { AppBar, Toolbar, Avatar, Box, Typography, MenuItem, Select} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { styles } from '../../classes/Styles'

class TrackerHeaderComponent extends React.Component {
  static propTypes = {
    tracker: PropTypes.object,
    history: PropTypes.object,
    trackerPlan: PropTypes.object,
    primaryEntityDetails: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    })
  }

  constructor (props) {
    super(props)

    this.state = {
      selectedTracker: ''
    }
  }

  componentDidMount () {
    if (this.props.trackerPlan.details) {
      this.setState({ selectedTracker: this.props.trackerPlan.details.tracker_topic.tracker_name})
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.trackerPlan !== this.props.trackerPlan && this.props.trackerPlan.details) {
      this.setState({ selectedTracker: this.props.trackerPlan.details.tracker_topic.tracker_name})
    }
  }

  changeTracker = (id, name) => {
    this.setState({ selectedTracker: name})
    this.props.history.push(`/insights/tracker/${id}`)
  }

  render () {
    const { tracker } = this.props
    let trackers = tracker && tracker.details && tracker.details.trackers.sort((a, b) => (a.tracker_name < b.tracker_name) ? -1 : (a.tracker_name > b.tracker_name) ? 1 : 0)
    return (
      <AppBar position="static" color="transparent" elevation={0} className="header">
        <Toolbar disableGutters={true} justify="center">
          <Avatar alt="Tracker title icon" src="/static/images/tracker.png" variant="square" className="titleIcon"></Avatar>
          { (this.props.shortcut || (trackers && trackers.length === 1)) &&
            <Box pl={1} className='shortcutTitle'>
              <Typography>
                <span className="title">{this.state.selectedTracker}</span>
              </Typography>
            </Box>
          }
          { (!this.props.shortcut && (trackers && trackers.length > 1)) &&
            <Box pl={1}>
              <Select
                value={this.state.selectedTracker}
                >
                { trackers && trackers.map(tracker => {
                  return (
                    <MenuItem value={tracker.tracker_name} key={tracker.tracker_id} onClick={() => this.changeTracker(tracker.tracker_id, tracker.tracker_name)}>
                      <span className="title">{tracker.tracker_name}</span>
                    </MenuItem>
                  )
                })}
              </Select>
            </Box>
          }
        </Toolbar>
      </AppBar>
    )
  }
}

export default withStyles(styles)(TrackerHeaderComponent)
